import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type ContextValueType } from '../types';
import { type OnboardingAnalyticsCategory } from './onboardingAnalytics';
import META from './useTrackContextFieldAdded.meta';

export type UseTrackContextFieldAddedParams = {
  source: OnboardingAnalyticsCategory | 'add_domain' | 'manual';
  field_name: string;
  value_type: ContextValueType;
};

export const useTrackContextFieldAdded = () => {
  const { track } = useAnalyticsUtilities();

  const trackContextFieldAdded = useCallback(
    (params: UseTrackContextFieldAddedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackContextFieldAdded };
};
